import React from 'react';
import './ExpertsList.css';
import profilePicImage from '../assets/images/Profilepic.png';

const profilePic = profilePicImage;

const experts = {
  trending: [
    { id: 1, name: 'Sarah Johnson', title: 'Life Coach & Motivational Speaker', rating: 4.9, reviews: 128, image: profilePic },
    { id: 2, name: 'Michael Chen', title: 'Business Strategy Consultant', rating: 4.8, reviews: 93, image: profilePic },
    { id: 3, name: 'Emma Davis', title: 'Career Development Specialist', rating: 4.7, reviews: 156, image: profilePic }
  ],
  acting: [
    { id: 4, name: 'James Wilson', title: 'Acting Coach & Theater Director', rating: 4.9, reviews: 142, image: profilePic },
    { id: 5, name: 'Maria Garcia', title: 'Method Acting Instructor', rating: 4.8, reviews: 87, image: profilePic },
    { id: 6, name: 'David Lee', title: 'Voice & Movement Coach', rating: 4.7, reviews: 112, image: profilePic }
  ],
  art: [
    { id: 7, name: 'Lisa Thompson', title: 'Fine Arts Instructor', rating: 4.9, reviews: 165, image: profilePic },
    { id: 8, name: 'Robert Kim', title: 'Digital Art Specialist', rating: 4.8, reviews: 94, image: profilePic },
    { id: 9, name: 'Anna Martinez', title: 'Mixed Media Artist', rating: 4.7, reviews: 138, image: profilePic }
  ]
};

const StarRating = ({ rating }) => {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= Math.round(rating) ? 'filled' : ''}`}
        >
          ★
        </span>
      ))}
    </div>
  );
};

const ExpertsList = ({ activeTopic }) => {
  const topicExperts = experts[activeTopic] || [];

  return (
    <div className="experts-list">
      {topicExperts.map((expert) => (
        <div key={expert.id} className="expert-card">
          <div className="expert-image">
            <img src={expert.image} alt={expert.name} />
          </div>
          <div className="expert-info">
            <h3>{expert.name}</h3>
            <p className="expert-title">{expert.title}</p>
            <div className="expert-rating">
              <StarRating rating={expert.rating} />
              <span className="rating-number">{expert.rating}</span>
              <span className="reviews-count">({expert.reviews} reviews)</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpertsList; 